import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { translationHookOptions } from "../../app/localization/localization";
import { ITenant } from "../../app/models/tenant";
import { RootStoreContext } from "../../app/stores/rootStore";
import SidebarGenericButton from "./SidebarGenericButton";

interface IParams {
  tenant: ITenant;
  currentUrl?: string;
}

const SidebarRepositoryButton: React.FC<IParams> = ({ tenant, currentUrl }) => {
  const rootStore = useContext(RootStoreContext);
  const { currentTenant } = rootStore.tenantStore;
  const { enabledRepository } = rootStore.playerStore;
  const {isMobileMediaQuery,setIsSidebarModalOpen} = rootStore.responsiveStore;
  const [t] = useTranslation(["translation"], translationHookOptions);

  return (
    <>
      {enabledRepository ? (
        <div className={classNames(isMobileMediaQuery? "col-6 mobileSidebarButtonContainer" : "", "pt-0 pb-0")}>
          <Link to={`${currentTenant!.path}/repository`} className=" pb-0">
            <SidebarGenericButton
              icon={"far fa-cabinet-filing"}
              label={t("sidebar_btn_mydocs")}
              isActive={currentUrl === `${tenant.path}/repository`}
              onClick={()=> isMobileMediaQuery && setIsSidebarModalOpen(false)}
              />
          </Link>
        </div>
      ) : null}
    </>
  );
};

export default observer(SidebarRepositoryButton);
